<script setup lang="ts">
import { DialogTitle } from "@headlessui/vue";
import type { Component } from "vue";

defineProps<{
  as?: string | Component;
}>();
</script>

<template>
  <DialogTitle :as="as">
    <slot />
  </DialogTitle>
</template>

<style scoped lang="scss">

</style>
